<template>
	<v-dialog v-model="dialogState" width="600">
		<v-card>
			<v-card-title class="headline">
				Wysyłka raportu
			</v-card-title>

			<v-card-text>
				Przed wysłaniem sprawozdania upewnij się, że jest poprawnie wypełnione.
				Po wysłaniu nie będzie już możliwości edycji!
			</v-card-text>

			<v-alert :value="true" type="info" outline class="ml-4 mr-4 mb-3">
				Po wysłaniu sprawozdania należy złożyć jego podpisaną wersję!
			</v-alert>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="success" flat @click="action" :loading="loading" :disabled="loading">
					<v-icon color="white" class="mr-2 white--text">send</v-icon>
					Wyślij
				</v-btn>
				<v-btn color="blue" @click="dialogState = false">
					<v-icon color="white" class="mr-2 white--text">close</v-icon>
					Anuluj
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: "AgencyProjectFinalReportConfirmationDialog",

		data () {
			return {
				dialogState: false,
			};
		},

		watch: {
			dialogModel: function () {
				this.dialogState = this.dialogModel;
			},

			dialogState: function (val) {
				if (!val) this.$emit("close-confirmation");
			}
		},

		props: {
			dialogModel: Boolean,
			header: String,
			content: String,
			actionLabel: String,
			icon: String,
			action: Function,
			loading: {type: Boolean, default: false}
		}
	};
</script>

<style scoped>

</style>
